module.exports = __webpack_public_path__ + "img/cart.f8b68207.svg";